export enum Environment {
    Production = "production",
    Staging = "staging",
    Development = "development",
    Local = "local",
}
